<template>
  <modal name="modal-confirmacao-sair" scrollable width="400" height="auto">
    <div style="padding: 32px">
      <h2 class="text-center">
        {{
          modoRascunho ? "⚠️ Deseja sair do fluxo?" : "⚠️ Alterações não salvas"
        }}
      </h2>
      <div class="warning-messages-container">
        <template v-if="modoRascunho">
          <div class="d-block text-center" style="margin-top: 24px">
            Você deseja salvar um rascunho local antes de sair?
          </div>
          <div class="d-block text-center text-muted" style="margin-top: 12px">
            {{ ultimoSalvamentoLocal }}
          </div>
        </template>
        <div v-else class="d-block" style="margin-top: 32px">
          * Tem certeza que deseja sair e descartar as alterações?
        </div>
      </div>
      <div
        class="buttons-container"
        style="
          display: flex;
          gap: 1rem;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          margin-top: 32px;
        "
      >
        <template v-if="modoRascunho">
          <b-button
            class="w-100 text-uppercase"
            variant="success"
            @click="$emit('salvar-rascunho-sair')"
          >
            Salvar rascunho e sair
          </b-button>
          <b-button
            class="w-100 text-uppercase"
            variant="outline-danger"
            @click="$emit('sair-sem-salvar')"
          >
            Sair sem salvar
          </b-button>
          <b-button
            class="w-100 text-uppercase"
            variant="secondary"
            @click="fecharModalSaida"
          >
            Continuar editando
          </b-button>
        </template>
        <template v-else>
          <b-button
            class="w-100 text-uppercase"
            variant="success"
            @click="redirectToCampanhas"
            >Sim</b-button
          >
          <b-button
            class="w-100 text-uppercase"
            variant="danger"
            @click="fecharModalSaida"
            >Não</b-button
          >
        </template>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "ModalConfirmacaoSair",
  props: {
    aba: {
      type: Number,
      default: 0
    },
    modalRegister: {
      type: Boolean
    },
    direct_page: {
      type: String
    },
    modoRascunho: {
      type: Boolean,
      default: false
    },
    ultimoSalvamentoLocal: {
      type: String,
      default: "Nenhum backup local foi salvo ainda."
    }
  },
  methods: {
    fecharModalSaida() {
      this.$modal.hide("modal-confirmacao-sair");
      this.$emit("continuar-editando");
    },
    redirectToCampanhas() {
      if (this.direct_page) {
        this.$router.push({
          name: this.direct_page
        });
        return;
      }
      if (this.modalRegister) {
        this.$modal.hide("modal-confirmacao-sair");
      }
      this.$router.push({
        name: "automacao",
        params: {
          navSelecionada: this.aba
        }
      });
    }
  }
};
</script>

<style></style>
